module.exports = __webpack_public_path__ + "img/coupon_mb_tab_01.c6d5de41.png";